<script setup>
/*
 * Tegner en raekke blokke.
 *
 * Komponenten slaas op i et FAST kort og ikke dynamisk pr. navn: en
 * import() paa en streng fra databasen ville betyde at Vite ikke kan se
 * hvilke komponenter der faktisk bruges, og SSR-bundtet ville mangle dem.
 *
 * <component :is> er fint her i broedteksten. Den maa IKKE bruges inde i
 * <Head> — dér vaelter den SSR og giver en hvid side.
 */
import { computed } from 'vue';
import Tekst from './Tekst.vue';
import Produktliste from './Produktliste.vue';
import Enhedsprisliste from './Enhedsprisliste.vue';
import Tilbudsvurdering from './Tilbudsvurdering.vue';
import Daekning from './Daekning.vue';
import Pcbygger from './Pcbygger.vue';
import Spilkrav from './Spilkrav.vue';
import Produktkort from './Produktkort.vue';
import Prisgraf from './Prisgraf.vue';
import ForOgImod from './ForOgImod.vue';
import Delvurdering from './Delvurdering.vue';
import Samletvurdering from './Samletvurdering.vue';
import Specifikationer from './Specifikationer.vue';
import Punktliste from './Punktliste.vue';
import Kampagnetilbud from './Kampagnetilbud.vue';
import Kampagnelinks from './Kampagnelinks.vue';
import Nedtaelling from './Nedtaelling.vue';
import SamletSetup from './SamletSetup.vue';
import Prisudvikling from './Prisudvikling.vue';
import Butiksvilkaar from './Butiksvilkaar.vue';
import Prisalarm from './Prisalarm.vue';
import StortBillede from './StortBillede.vue';
import Indlejring from './Indlejring.vue';

const KOMPONENTER = {
    Tekst,
    Produktliste,
    Enhedsprisliste,
    Tilbudsvurdering,
    Daekning,
    Pcbygger,
    Spilkrav,
    Produktkort,
    Prisgraf,
    ForOgImod,
    Delvurdering,
    Samletvurdering,
    Specifikationer,
    Punktliste,
    Kampagnetilbud,
    Kampagnelinks,
    Nedtaelling,
    SamletSetup,
    Prisudvikling,
    Butiksvilkaar,
    Prisalarm,
    StortBillede,
    Indlejring,
};

const props = defineProps({
    blokke: { type: Array, default: () => [] },
});

// En blok hvis komponent ikke findes i bundtet springes over frem for at
// vaelte siden. Samme princip som paa serveren.
const synlige = computed(() => props.blokke.filter((b) => KOMPONENTER[b.komponent]));

function komponent(navn) {
    return KOMPONENTER[navn];
}
</script>

<template>
    <div class="blokliste">
        <template v-for="blok in synlige" :key="blok.id">
            <section class="blok" :class="[`blok--${blok.type.toLowerCase()}`, { 'blok--aabn': blok.aabnGruppe, 'blok--luk': blok.lukGruppe }]">
                <h2 v-if="blok.overskrift" class="blok__overskrift">{{ blok.overskrift }}</h2>
                <component :is="komponent(blok.komponent)" :data="blok.data" :blok="blok" />
            </section>
        </template>
    </div>
</template>

<style scoped>
.blok { margin-bottom: 2rem; }
.blok__overskrift { font-size: 1.5rem; margin-bottom: 0.75rem; }
</style>
